import { mapDeals } from '../helpers';
const setDealDetails = _ref => {
  let {
    types
  } = _ref;
  return payload => dispatch => {
    // Allow response to be passed as is (as an array) to reuse mapping logic here
    const mappedDeals = mapDeals(payload);
    dispatch({
      type: types.SET_DEAL_DETAILS,
      payload: {
        ...mappedDeals
      }
    });
  };
};
export default setDealDetails;